import React from 'react';
import { Text, Badge } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const SenderNameCell = (params) => {
    const { value, data } = params;
    return (
        <div className="sender-name-cell">
            <Text medium>{value}</Text>
            {data.default && (
                <Badge type="actionMinor">
                    {getLiteral('label_marketing_campaigns_default_sender')}
                </Badge>
            )}
        </div>
    );
};

export default SenderNameCell;
